import React from 'react'
import styles from 'css/pages/student-live.module.css'
import { ConnectingPage, DoneEarlyPage } from 'components/presentation-status-page'
import { BlueButton } from 'components/blue-button'
import type { SubmitState } from './use-student-answers'

interface StudentDoneViewProps {
	submitState: SubmitState
	onRetry: () => void
}

/** The three states a student can land on after clicking Done: saving, a
 * failed save with a retry that doesn't lose their work, or the normal
 * "you're finished, others are still working" screen. */
export const StudentDoneView = ({ submitState, onRetry }: StudentDoneViewProps) => {
	switch (submitState) {
		case 'saving':
			return <ConnectingPage />
		case 'error':
			return (
				<div className={styles.questionContent} style={{ textAlign: 'center' }}>
					<h2>We couldn't save your answers</h2>
					<p style={{ fontSize: '18px' }}>Don't close this tab! Your work is still here.<br />Tell your teacher, then press Try Again.</p>
					<BlueButton label="Try Again" onClick={onRetry} />
				</div>
			)
		default:
			return <DoneEarlyPage />
	}
}
